import { Box, Container, Stack, styled } from '@ethings/ui-toolkit';
import { FC, type JSX } from 'react';
import { FlexBox } from '../../components';

interface Props {
  content: JSX.Element;
  pageActions: JSX.Element;
}

const StyledContainer = styled(Container)({
  flexGrow: 1,
  py: 3,
  overflowX: 'hidden',
});

const StyledStickyBox = styled(Box)(({ theme }) => ({
  position: 'sticky',
  bottom: 0,
  backgroundColor: theme.palette.background.paper,
  borderTop: `1px solid ${theme.palette.divider}`,
  zIndex: 10,
}));

export const ProfilePageMobileLayout: FC<Props> = ({ content, pageActions }) => (
  <FlexBox flexDirection="column" height="100%">
    <FlexBox flexDirection="column" overflow="auto" flex={1}>
      <StyledContainer id="detail-page">
        <Stack id="content" className="detail-content" direction="column" display="flex" mt={2} spacing={2}>
          <Stack
            direction="column"
            flex={[3, 3]}
            spacing={2}
            minWidth={0}
          >
            {content}
          </Stack>
        </Stack>
      </StyledContainer>
    </FlexBox>
    <StyledStickyBox>
      {pageActions}
    </StyledStickyBox>
  </FlexBox>
);
